import Vue from 'vue'

// 遍历components目录下所有.vue文件，false=不递归扫子目录（要递归改true即可，脚本自带容错不会报错）
const componentContext = require.context('./', false, /\.vue$/)

componentContext.keys().forEach(filePath => {
  // 跳过index.js自身
  if (filePath === './index.js') return

  // 兼容两种导出方式：export default / module.exports
  const module = componentContext(filePath)
  const componentConfig = module.default || module

  // 无效模块（空文件、非vue组件、语法错误的文件）直接跳过，不阻断注册
  if (!componentConfig || typeof componentConfig !== 'object') {
    console.warn('[组件注册] 跳过无效文件:', filePath)
    return
  }

  // 优先取组件内部写的name，没写就自动从文件名生成组件名
  let componentName = componentConfig.name
  if (!componentName) {
    const fileName = filePath.split('/').pop().replace(/\.\w+$/, '')
    componentName = fileName.replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '')
    console.warn(`[组件注册] ${filePath} 未配置name，自动使用文件名: ${componentName}`)
  }

  if (typeof componentName !== 'string') {
    console.warn('[组件注册] 无法获取组件名，跳过:', filePath)
    return
  }

  // 驼峰转横杠命名（符合Vue自定义标签规范）
  const tagName = componentName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  Vue.component(tagName, componentConfig)
 // console.log('[组件注册] 成功:', tagName)
})
